import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function RequireAuth({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-black text-zinc-500 flex items-center justify-center font-mono text-xs tracking-widest">LOADING...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center gap-4 p-6">
        <div className="font-display text-4xl uppercase">Access denied</div>
        <div className="text-zinc-500 text-sm">Your role: <span className="text-sky-400">{user.role}</span></div>
        {user.role === "pending" && (
          <div className="text-zinc-400 text-sm max-w-md text-center">
            Ο λογαριασμος σου περιμενει εγκριση απο τον admin. Θα ενημερωθεις μολις γινει member.
          </div>
        )}
      </div>
    );
  }
  return children;
}
